// @flow
import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment';

import AnalyticsBase from '../AnalyticsBase';
import AnalyticsFilterBar from '../AnalyticsFilterBar';
import BreadcrumbNav from '../../nav/BreadcrumbNav';

import { initializeAnalytics } from '../../../state/reducer/analytics/actionCreators/initializeAnalytics';
import * as DateUtils from '../../../lib/dateUtils';
import * as AnalyticsState from '../../../state/reducer/analytics/analytics';

import Console from '../../../lib/debug';
import KPIBar from '../KPIBar';

type Props = {
    dispatch: any => void
};

const PAGE_KEY = 'marketplace-trials';
const minDate = moment('2020-11-01', 'YYYY-MM-DD');

class MarketplaceTrialsView extends Component<Props> {
    constructor(props: Props) {
        super(props);
        this.loadAnalytics();
    }

    componentDidUpdate(prevProps: {}, prevState: {}) {
        this.loadAnalytics();
    }

    loadAnalytics = () => {
        const dataParams = this.getDataParams();
        this.props.dispatch(initializeAnalytics(PAGE_KEY, dataParams));
    };

    setSearchParams = (params: {}) => {
        const existingParams = AnalyticsState.getSearchParams();
        AnalyticsState.updateSearchParams({
            ...existingParams,
            ...params
        });
    };

    getDataParams = () => {
        const searchParams = AnalyticsState.getSearchParams();

        let startDate = searchParams.start_date;
        if (!DateUtils.isValidDateString(startDate)) {
            startDate = moment().startOf('month');
        } else {
            startDate = moment(startDate);
        }

        if (startDate.isBefore(minDate)) {
            startDate = minDate.clone();
        }

        let endDate = startDate.clone().endOf('month');
        endDate = moment(endDate, DateUtils.CALENDAR_FORMAT);

        return {
            date_start: moment(startDate).format(DateUtils.CALENDAR_FORMAT),
            date_end: moment(endDate).format(DateUtils.CALENDAR_FORMAT)
        };
    };

    getStartDate = () => {
        const dataParams = this.getDataParams();
        return moment(dataParams.date_start);
    };

    getEndDate = () => {
        const dataParams = this.getDataParams();
        return moment(dataParams.date_end);
    };

    onSelectDateRange = ({ startDate }: {}) => {
        const formattedStartDate = startDate.format(DateUtils.CALENDAR_FORMAT);

        this.setSearchParams({
            start_date: formattedStartDate
        });
    };

    getPageTitle = () => {
        let title =
            this.props.metaTree &&
            this.props.metaTree.instances &&
            this.props.metaTree.instances[PAGE_KEY] &&
            this.props.metaTree.instances[PAGE_KEY].title;
        if (title) {
            return title;
        }
        return '';
    };

    render() {
        Console.render('MarketplaceTrialsView');
        const crumbs = [
            {
                displayString: 'Analytics',
                link: `/analytics`,
                editable: false
            },
            {
                displayString: this.getPageTitle(),
                link: null,
                editable: false
            }
        ];

        return (
            <div className="has-filter-bar">
                <BreadcrumbNav crumbs={crumbs} />
                <KPIBar />
                <AnalyticsFilterBar
                    monthSelection={{
                        minDate: minDate,
                        startDate: this.getStartDate(),
                        endDate: this.getEndDate(),
                        onChange: this.onSelectDateRange
                    }}
                />
                <AnalyticsBase includeKpi={true} />
            </div>
        );
    }
}

const mapStateToProps = (state: any, ownProps: any) => {
    return {
        ...ownProps,
        metaTree: state.analytics.metaTree
    };
};

export default connect(mapStateToProps)(MarketplaceTrialsView);



// WEBPACK FOOTER //
// ./src/view/analytics/marketplace/MarketplaceTrialsView.jsx